<!-- OTHER INPUTS -->
<div class="validable-input-margins" [formGroup]="formGroup">
  <div class="input-group">
    <div
      class="input-group-prepend form-icon col-1 justify-content-center align-items-center"
    >
      <i class="material-icons notranslate">{{ icon }}</i>
    </div>
    <mat-form-field
      appearance="outline"
      [ngClass]="{ 'has-primary': this.isValid === true }"
      [ngClass]="displayErrors(customId)"
      class="col {{this.classes}}"
    >
      <mat-label>{{ text | translate }}</mat-label>
      <input
        #internalInput
        type="{{ type }}"
        matInput
        name="{{ customId }}"
        placeholder="{{ text | translate }}"
        (ngModelChange)="validation($event)"
        value="{{ currentValue }}"
        min="{{ min }}"
        max="{{ max }}"
        maxlength="{{maximumLength}}"
        formControlName="{{ customId }}"
      />

      <app-field-error-display
        [displayError]="isFieldNotValid(customId)"
        [errorMsg]="getErrorText() | translate"
      >
      </app-field-error-display>
    </mat-form-field>
  </div>
</div>
